import React from 'react'
import ImageGallery from '../../genericComponents/ImageGallery'
import Modal from '../../genericComponents/Modal'
import s from './GeoentityBlockImageList.less'
import { useAction } from '../../utils/react-redux'
import { isGE, isPE } from '../../Device'
import ThreeImageGrid from '../../genericComponents/ThreeImageGrid'
import { checkBlockAspectFitsWhitelist } from './GeoentityBlockUtils'
import { navigateTo } from '../../../store/history/history.actions'
import { ROUTE_MODAL } from '../../../routes'

export const GeoentityBlockImageList = props => {
  if (!checkBlockAspectFitsWhitelist(['classic'], props.data)) return null

  return <ImageList {...props} />
}

const ImageList = props => {
  return props.data.rotate ? <RotatedImageList {...props} /> : <GalleryImageList {...props} />
}

const RotatedImageList = ({ data: { list = [] } }) => {
  const { templatizedUrl } = list[0] || {}

  return (
    <ImageGallery
      additionalClass={s.RotatedImageList}
      style={{ cursor: 'pointer' }}
      autoPlay
      swipingTransitionDuration={750}
      showNav
      items={list.map(({ image }) => ({
        original: image
      }))}
      onClick={() => templatizedUrl && window.open(templatizedUrl)}
    />
  )
}

const MODAL_ID = 'gallerie_image'

const GalleryImageList = ({ data: { list = [] } }) => {
  const execNavigateTo = useAction(navigateTo)

  const allImages = list.map(({ image }) => image)

  return (
    <>
      <ThreeImageGrid
        images={allImages}
        onClick={() =>
          execNavigateTo({
            route: ROUTE_MODAL,
            routeOptions: { modalId: MODAL_ID }
          })
        }
      />
      <Modal
        modalId={MODAL_ID}
        withCloseButton
        style={
          isGE()
            ? {
                padding: '45px 10px 10px 10px',
                maxWidth: '680px'
              }
            : {
                backgroundColor: 'transparent',
                borderRadius: 0,
                border: 'none',
                width: '100%'
              }
        }
        overlayStyle={
          isPE() && {
            backgroundColor: 'black'
          }
        }
        execNavBackOnClose={true}
      >
        <ImageGallery
          showThumbnails={isGE()}
          showNav={isGE()}
          items={list.map(({ image, thumbnail }) => ({
            original: image,
            thumbnail: thumbnail || image,
            originalClass: s.MainImage,
            thumbnailClass: s.ThumbnailImage,
            originalAlt: `Impossible de charger le contenu demandé.\nVeuillez réessayer plus tard.`
          }))}
        />
      </Modal>
    </>
  )
}

export default GeoentityBlockImageList
